import styled from 'styled-components';
import UpcomingEmptySvg from '../../assets/mytrips/ic-upcoming-empty.svg';

const UpcomingEmptyIcon = styled(UpcomingEmptySvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '12rem'};
  height: ${props => props.height || '11.4rem'};
  margin: ${props => props.margin};
`;

export default UpcomingEmptyIcon;
